import React, { FC } from 'react'
import s from './QuickSearchPlaceItem.module.sass'
import { useQuickSearch_search_v2_items_Place } from '@features/QuickSearch/useQuickSearch'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { Button } from '@shared/ui/Actions/Button'
import { EGG } from '@shared/api/analytics'

const QuickSearchPlaceItem: FC<{
  place: useQuickSearch_search_v2_items_Place
  index: number
  onClickLink?: () => void
}> = ({ place, index, onClickLink }) => {
  const reservationUrl = place?.features?.[0]?.reservationUrl
  const router = useRouter()

  const placeType = place?.features?.[0]?.mainTag?.name || 'Ресторан'

  const meta = place.address ? `${placeType} / ${place.address}` : placeType

  const handleClickItem = (e) => {
    e.stopPropagation()
    EGG.quickSearch.suggest_click({
      object_type: 'restaurant',
      object_id: place.id,
      section_index: index,
    })
    onClickLink && onClickLink()
  }

  return (
    <li className={s['item-row']}>
      <Link className={s['sprawled-link']} href={place.url} onClick={handleClickItem} />

      <div className={s['item-block']}>
        {place.name}
        {meta && <span className={s['item-meta']}>{meta}</span>}
      </div>

      {!!reservationUrl && (
        <Button
          sizes='S'
          mode='white-border'
          onClick={(e) => {
            e.stopPropagation()
            EGG.quickSearch.reserve_click({
              object_type: 'restaurant',
              object_id: place.id,
              section_index: index,
              rating: place.rating,
              afisha_selected: place.afishaChoice,
            })
            reservationUrl ? router.push(reservationUrl) : router.push(place.url)
          }}>
          Забронировать
        </Button>
      )}
    </li>
  )
}

export default QuickSearchPlaceItem
